import React       from 'react';
import queryString from 'query-string';

import values  from '../../../../../../values';
import Context from '../../../../../../context';

import { IOnSearchUser          } from '../../../../../../types/common.interface';
import { SearchDropDownWithBase } from '../../../../../../components';

const Search: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { requestArea, setRequestArea } = React.useContext(Context.Location.Area);
  const [defaultSearch, setDefaultSearch] = React.useState<string>(
    String(queryString.parse(window.location.search).search)?.split(':')[1]
  );
  const baseSearch = values.dropdownBaseSearch.LOCATION_PROVINCE_BASE_SEARCH;

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onSearch(event: IOnSearchUser): void {
    setRequestArea!({
      ...requestArea,
      search: event?.searchedValue,
      page: 1,
    });
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <SearchDropDownWithBase
      icon="fa-solid fa-magnifying-glass"
      defaultSearch={defaultSearch}
      size="medium-sd"
      onChangeSearch={(event: IOnSearchUser) => {
        onSearch(event);
        setDefaultSearch(event.searchedValue);
      }}
      defaultBaseSearch={baseSearch[0]}
      baseSearchItems={baseSearch.map((item) => ({
        ...item,
        title: item.title,
      }))}
    />
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Search;
